"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventTypesMap = new Map([
    [0, 'Boot'],
    [1, 'Power'],
    [2, 'Error'],
    [3, 'Battery'],
    [4, 'Device lock'],
    [5, 'Bluetooth'],
]);
exports.default = EventTypesMap;
